import AgreementModal from "./agreement-modal";

export default AgreementModal;
